export const colors = {
  page: "var(--ac-page, #f3f7fb)",
  sidebar: "var(--ac-surface, #ffffff)",
  surface: "var(--ac-surface, #ffffff)",
  surfaceAlt: "var(--ac-surface-alt, #f8fbff)",
  surfaceSoft: "var(--ac-surface-soft, #eef3f9)",
  border: "var(--ac-border, #dce6f2)",
  text: "var(--ac-text, #001432)",
  muted: "var(--ac-muted, #526783)",
  softMuted: "var(--ac-soft-muted, #8fa0bb)",
  primary: "#4f46e5",
  green: "#0e9f7b",
  blue: "#177dd2",
  royal: "#315eea",
  purple: "#6736dd",
  magenta: "#ad22c7",
  orange: "#df6800",
  red: "#d7194f",
  teal: "#0783a8",
  navy: "#17243a",
};

export const metricGradients = {
  green: "linear-gradient(135deg, #0da879 0%, #087765 100%)",
  blue: "linear-gradient(135deg, #1689d8 0%, #1d58d3 100%)",
  royal: "linear-gradient(135deg, #5069f5 0%, #2855df 100%)",
  purple: "linear-gradient(135deg, #5b3bea 0%, #6a27dc 100%)",
  magenta: "linear-gradient(135deg, #ad2ddb 0%, #a113b7 100%)",
  orange: "linear-gradient(135deg, #e17400 0%, #cf3c00 100%)",
  red: "linear-gradient(135deg, #e01f55 0%, #c70e3b 100%)",
  teal: "linear-gradient(135deg, #119bb5 0%, #05759e 100%)",
  navy: "linear-gradient(135deg, #26354d 0%, #111b30 100%)",
};

